export default "__VITE_ASSET__DKr_foLm__"